/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".switch.danger-switch[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%]:checked + .lever[_ngcontent-%COMP%]{background-color:#ff606f}.switch.danger-switch[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%]:checked + .lever[_ngcontent-%COMP%]:after{background-color:#ff3547}"];
export { styles as styles };
